<template>
    <pm-custom-dialog v-if="visible" v-model="visible">
        <span v-if="!reason" slot="close-btn"></span>


        <template v-if="!reason">

            <div style="background: url(/images/onboarding/onboarding-consultation.jpg) center center / contain no-repeat rgb(255, 255, 255); margin: 0px 0px 20px 0; width: 100%; height: 120px;"></div>

            <div style="margin-bottom: 16px; margin-top: 20px; text-align: center;">

                <h2 style="line-height: 1.2; font-weight: 600; text-shadow: 0.5px 0.5px 0 #000;">
                    Your opinion matters
                </h2>
            </div>

            <p style="line-height: 1.3; font-size: 15px; margin-bottom: 8px; padding: 8px 30px;">
                We want DentiCalc to be the best dental app that <b>helps you in your consultations</b>.
                <br/><br/>
                Please select <b>what you think</b><br/>about subscribing DentiCalc PREMIUM:
            </p>
            <br/>
            <a class="retry-btn mb-3 pm-animation-fade-in-slide-down" style="--delay: 50ms" @click="reason='expensive'">
                Not sure if it's worth it
            </a>
            <br/>
            <a class="retry-btn mb-3 pm-animation-fade-in-slide-down" style="--delay: 100ms" @click="reason='not_dentist'">
                I’m not a dentist
            </a>
            <br/>
            <a class="retry-btn mb-3 pm-animation-fade-in-slide-down" style="--delay: 150ms" @click="reason='not_tried'">
                I haven't tried it yet
            </a>
            <br/>
            <a class="retry-btn mb-3 pm-animation-fade-in-slide-down" style="--delay: 150ms;" @click="reason='other'">
                Other
            </a>

        </template>

        <template v-if="reason==='not_dentist'">
            <div style="background: url(/images/onboarding/ratings.jpg) center center / contain no-repeat rgb(255, 255, 255); margin: 40px 0px 20px 0; width: 100%; height: 170px;"></div>

            <p style="line-height: 1.3; font-size: 15px; margin-bottom: 8px; padding: 8px 30px;">
                Thank you for downloading DentiCalc. We hope you <b>liked it anyway.</b>
                <br/><br/>
                We kindly ask you to leave positive feedback and <b>recommend DentiCalc to your dentists</b>.
                <br/><br/>
            </p>

            <a class="retry-btn mb-3 pm-animation-fade-in-slide-down" style="--delay: 50ms" @click="openReview">
                RATE US
            </a>
            <br/>

            <a class="retry-btn mb-3 pm-animation-fade-in-slide-down" style="--delay: 50ms" @click="openShare">
                SHARE <span style="text-transform: none; font-weight: 600;">&nbsp;DentiCalc</span>
            </a>
            <br/>

            <a class="retry-btn mb-3 pm-animation-fade-in-slide-down" style="--delay: 50ms" @click="close">
                CLOSE
            </a>
        </template>
    </pm-custom-dialog>
</template>
<script>
import PmCustomDialog from "./base-dialog.vue";
import { trialDaysLeft } from "@/utils/iap/trial-days";
import { share } from '@/utils/device/share';
export default {
    components: {
        PmCustomDialog,
    },
    data: () => ({
        reason: "",
        visible: false,
    }),
    watch: {
        reason() {
            localStorage.setItem('storeCancelReason', this.reason);
            window.Tracker.logEvent({
                event_name: "cancel_reason",
                event_category: "iap",
                event_label: this.reason,
            });

            if (this.reason === "not_tried") {
                if (trialDaysLeft() <= 0 && !localStorage.getItem('extendedTrial')) this.$bus.$emit('openAppDialog','extraTrialOffer');
                else this.$bus.$emit('openAppDialog','trialDaysLeft');
            }
            if (this.reason === "expensive" || this.reason === "other") {
                this.$bus.$emit('openAppDialog','priceWorthIt');
            }
        },
    },
    methods: {
        openReview() {
            this.$bus.$emit('openAppDialog','review');
            window.Tracker.logEvent({
                event_name: "init",
                event_category: "review",
                event_label: "cancel_dialog_" + this.reason,
            });
        },
        openShare() {
            const text = "Check out this great dental app!"; // this text will be used by most channels
            const subject = "Dental app for professionals"; // will be used only when shared in email
            // @ts-ignore
            const url = this.$isIOS()
                ? "https://apps.apple.com/us/app/id1537539049"
                : "https://play.google.com/store/apps/details?id=com.denticalc.demo";

            window.Tracker.logEvent({
                event_name: "init",
                event_category: "share",
                event_label: "cancel_dialog_" + this.reason,
            });

            share(text, subject, url);
        },
        show() {
            this.visible = true;
        },
        close() {
            this.visible = false;
            this.$emit('close');
        },
    }
}
</script>
